<template>
    <div class="table-tr">
        <div class="table-td cell-availability" :class="{ 'transparent-indicator-red': !inPast && record.cancelled_slots, 'indicator-background-grey': inPast || record.cancelled_slots.length === 0 }">
            <div class="availability-date">
                <div v-for="({ date, times }, k) in record.cancelled_slots" :key="k">
                    <span v-for="([start_time, end_time], l) in times" :key="l">
                        <strong>
                            <div>{{ moment(date).format('ddd D.') }} {{ monthNameDeclension(moment(date).format('M')) }} {{ moment(date).format('YYYY') }}</div>
                            |
                            <div>{{ moment(start_time).format('H:mm') }}</div>
                            <div>-</div>
                            <div>{{ moment(end_time).format('H:mm') }}</div>
                        </strong>
                    </span>
                </div>
            </div>
        </div>

        <div class="table-td cell-availability" :class="{ 'transparent-indicator-green': !inPast, 'indicator-background-grey': inPast }">
            <div class="availability-date">
                <div v-for="({ date, times }, k) in sortedItems" :key="k">
                    <span v-for="([start_time, end_time], l) in times" :key="l">
                        <strong>
                            <div>{{ moment(date).format('ddd D.') }} {{ monthNameDeclension(moment(date).format('M')) }} {{ moment(date).format('YYYY') }}</div>
                            |
                            <div>{{ moment(start_time).format('H:mm') }}</div>
                            <div>-</div>
                            <div>{{ moment(end_time).format('H:mm') }}</div>
                        </strong>
                    </span>
                </div>
            </div>
        </div>
        <div class="table-td cell-availability">
            <div class="availability-time">
                <strong>
                    {{ __choice('{0} :hours hours|{1} :hours hour hours|[2,4] :hours hours|[5,*] :hours hours', parseFloat(record.duration), { hours: record.duration }) }}
                </strong>
                <a
                    v-if="!inPast"
                    data-dismiss="modal"
                    data-target="#modal-delete-availability"
                    data-toggle="modal"
                    href="#"
                    @click.prevent="$parent.$emit('remove', { record, type })"
                >
                    <span class="material-icons-outlined">delete</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        record: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },
    computed: {
        inPast() {
            return this.type === 'older'
        },
        sortedItems() {
            return this.record.new_slots.sort((a, b) => new Date(a.date) - new Date(b.date))
        }
    }
}
</script>
